import {Component, OnInit} from '@angular/core';
import {News} from '../../models/models';
import {Translation} from '../../models/translation';
import {NewsService} from '../../services/news.service';
import {LoginService} from '../../services/login.service';
import Swal from 'sweetalert2';

class Company {
  value: string;
  text: string;
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  constructor(
    private newsService: NewsService,
    private loginService: LoginService
  ) { }

  public translation: Translation;
  public allNews: News[];
  public news: News[];
  public companies: Company[] = [];
  public companySelection = 'cotra.ch';
  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.companies = [
      { value: 'Alle', text: this.translation.All},
      { value: 'cotra.ch', text: 'Cotra'},
      { value: 'cartec.ch', text: 'Cartec'},
      { value: 'wheelnews.ch', text: 'Wheelnews'},
      { value: 'airportparking.ch', text: 'Airportparking'}];
    this.newsService.getNews().subscribe(response => {
      if (response.Ok) {
        this.allNews = response.Obj as News[];
        this.companySelectionChange();
      } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
      if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }

  companySelectionChange() {
    switch (this.companySelection) {
      case 'Alle': this.news = this.allNews; break;
      case 'cotra.ch': this.news = this.allNews.filter(o => o.Id.includes('cotra.ch')); break;
      case 'cartec.ch': this.news = this.allNews.filter(o => o.Id.includes('cartec.ch')); break;
      case 'wheelnews.ch': this.news = this.allNews.filter(o => o.Id.includes('wheelnews.ch')); break;
      case 'airportparking.ch': this.news = this.allNews.filter(o => o.Id.includes('airportparking.ch')); break;
      default: this.news = this.allNews;
    }
  }
}
